<template>
  <div>

  </div>
</template>

<script>
export default {
  name: 'commercialList',
};
</script>

<style scoped>

</style>
